/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validateTapToPayPolicy} from '../api'

export const useMutationValidateTapToPayPolicy = createReactQueryMutationHook('validateTapToPayPolicy', validateTapToPayPolicy)
